// WHAT CAN BE CHANGED?
// Put the desired links into the links-array under data()
// Make sure to enter the name, icon and route correctly
// You can also make style changes accordingly

<template>
  <div id="bottom-navigation">
    <router-link
      to="/"
      class="navigation-segment"
      id="navigation-segment__logo-segment"
      ><img
        alt="Company logo"
        src="@/assets/company-logo.png"
        id="navigation-segment__logo-segment__company-logo"
    /></router-link>

    <router-link
      v-for="link in links"
      v-bind:to="link.router"
      v-bind:key="link.name"
      class="navigation-segment"
    >
      <svg-icon
        class="navigation-segment__icon"
        v-bind:icon="link.icon"
        height="24px"
        width="24px"
      />
      {{ link.name }}
    </router-link>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
  name: "BottomNavigation",
  components: {
    SvgIcon,
  },
  data() {
    return {
      links: [
        { name: "Home", icon: "home", router: "/" },
        { name: "Luister", icon: "listen", router: "/listen" },
        // { name: "Bericht", icon: "message", router: "/bericht" },
        { name: "Bericht", icon: "message", router: "/message" },
        { name: "Kijk", icon: "watch", router: "/watch" },
        { name: "Gemist", icon: "missed", router: "/missed" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
$bottom-navigation__background--colour: #f2f2f2;
$bottom-navigation__icon--colour-selected: #FF6600;
$bottom-navigation__icon--colour-unselected: #959694;
$bottom-navigation__text--colour-selected: $bottom-navigation__icon--colour-selected;
$bottom-navigation__text--colour-unselected: $bottom-navigation__icon--colour-unselected;
$bottom-navigation__text--colour-hover: #3a3c39;
$bottom-navigation__text--font: "Lato";
$bottom-navigation__text--font-weight: bold;

#bottom-navigation {
  background-color: $bottom-navigation__background--colour;
  position: fixed;
  z-index: 99;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  font-family: $bottom-navigation__text--font;
  font-weight: $bottom-navigation__text--font-weight;
  #navigation-segment__logo-segment {
    display: none;
  }
  .navigation-segment {
    width: 100%;
    outline: none;
    text-decoration: none;
    max-width: 168px;
    color: $bottom-navigation__text--colour-unselected;
  }
  .navigation-segment:active {
    background-color: darken($bottom-navigation__background--colour, 10%);
  }
  .navigation-segment__icon {
    fill: $bottom-navigation__icon--colour-unselected;
    margin-bottom: 2px;
  }
  .router-link-exact-active {
    color: $bottom-navigation__text--colour-selected !important;
    .navigation-segment__icon {
      fill: $bottom-navigation__icon--colour-selected !important;
    }
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  body.when-keyboard-active #bottom-navigation {
    display: none;
  }
  #bottom-navigation {
    height: 56px;
    bottom: 0;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
    margin-bottom: env(safe-area-inset-bottom, 20px);
    .navigation-segment {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
    }
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  body.when-keyboard-active #bottom-navigation {
    display: none;
  }
  #bottom-navigation {
    height: 56px;
    bottom: 0;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
    .navigation-segment {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
    }
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  body.when-keyboard-active #bottom-navigation {
    display: none;
  }
  #bottom-navigation {
    height: 56px;
    bottom: 0;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
    .navigation-segment {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
    }
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #bottom-navigation {
    height: 80px;
    top: 0;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    justify-content: flex-start !important;
    align-items: center;
    #navigation-segment__logo-segment {
      display: flex;
      width: 168px;
      margin: 0;
      height: 80px;
    }
    #navigation-segment__logo-segment__company-logo {
      height: 50px;
    }
    .navigation-segment {
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
      font-size: 20px;
      height: 26px;
      width: auto;
      margin: 0px 20px;
      .navigation-segment__icon {
        display: none;
      }
    }
    .navigation-segment:active {
      background-color: transparent;
    }
    .navigation-segment:hover {
      color: $bottom-navigation__text--colour-hover;
      transition: 0.25s;
    }
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #bottom-navigation {
    height: 80px;
    top: 0;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    justify-content: flex-start !important;
    align-items: center;
    #navigation-segment__logo-segment {
      display: flex;
      width: 168px;
      margin: 0;
      height: 80px;
    }
    #navigation-segment__logo-segment__company-logo {
      height: 50px;
    }
    .navigation-segment {
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
      font-size: 20px;
      height: 26px;
      width: auto;
      margin: 0px 20px;
      .navigation-segment__icon {
        display: none;
      }
    }
    .navigation-segment:active {
      background-color: transparent;
    }
    .navigation-segment:hover {
      color: $bottom-navigation__text--colour-hover;
      transition: 0.25s;
    }
  }
}
</style>

<style lang="scss">
@media only screen and (min-device-width: 1800px) {
  #app {
    padding: 80px 0px 0px 0px;
  }
}
</style>
